// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthPage_root__1_zml","backgroundContainer":"AuthPage_backgroundContainer__32bvE","header":"AuthPage_header__2MgG8"};